import { Redirect, RouteProps, Route, useLocation } from "react-router-dom";
import { usePatientAuth } from "context/patient-auth";
import { PatientLayout } from "layouts/patient-layout";
import { Loading } from "components/loading";
import { getLoginRedirectUrl } from "helpers";

interface PatientRouteProps extends RouteProps {
  component: React.ComponentType<unknown>;
}

export function PatientRoute({
  component: Component,
  ...rest
}: PatientRouteProps) {
  const location = useLocation();
  const { isLoading, isAuthenticated } = usePatientAuth();
  const hasMagicLinkToken = new URLSearchParams(location.search).get("pa");

  if (isLoading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    if (hasMagicLinkToken) {
      return <Redirect to={`/login/verify${location.search}`} />;
    }
    return (
      <Redirect to={getLoginRedirectUrl(location.pathname, location.search)} />
    );
  }

  return (
    <Route {...rest}>
      <PatientLayout>
        <Component />
      </PatientLayout>
    </Route>
  );
}
